import React from "react";

import { FormFieldReset } from "~/components/form/reset";

import { Widget, WidgetBody, WidgetHeader } from "../../../_widget";
import { FormState } from "../../../widget-form/bar-chart/form-state";
import { Legend } from "../_legend";
import { ResetToDefaultSection } from "../_reset-to-default-section";
import { Thresholds } from "../_thresholds";
import { Labels } from "../_y-axis/labels";
import { Range } from "../_y-axis/range";

export interface BarChartProps {
	settings: FormState;
}

export const BarChart: React.FC<BarChartProps> = ({ settings }) => (
	<div className="grid h-full grid-cols-3 gap-4">
		<div className="flex flex-col gap-4">
			<Legend legend={settings.fields.legend} />
		</div>

		<div className="flex flex-col gap-4">
			<Labels yAxis={settings.fields.yAxis} />

			<Range range={settings.fields.range} />
		</div>

		<div className="flex flex-col gap-4">
			<Widget>
				<WidgetHeader className="uppercase" title="Thresholds">
					<FormFieldReset className="ml-auto" state={settings.fields.thresholds} />
				</WidgetHeader>

				<WidgetBody card>
					<Thresholds
						mode={settings.fields.thresholds.fields.mode}
						thresholds={settings.fields.thresholds.fields.steps}
					/>
				</WidgetBody>
			</Widget>

			<ResetToDefaultSection onClick={() => settings.setInput(FormState.initial)} />
		</div>
	</div>
);
